import {create} from 'zustand'
import {devtools} from 'zustand/middleware'

import { auth, checkAuth, getUserProfile, logout } from './api'
import {ILoginState, ILoginActions, IUserProfile} from './state.types'

import { resetStore } from '@api/store.reset'
import { tokenService } from '@services/token.service'
import { flushPendingClientErrors } from '@services/client-error.service'


export const initialStateLogin: ILoginState = {
    isLoading: false,
    isAuthorized: false,

    profile: {} as IUserProfile,
}

export const isAuthenticationRejected = (status: number) => [400, 401, 403].includes(status)

/** Хранилище страницы - Авторизация */
export const useLogin = create<ILoginState & ILoginActions>()(devtools((set) => ({
    ...initialStateLogin,

    /** Авторизация в системе */
    actionLogin: async (login: string, password: string) => {
        const response = await auth(login, password)

        if (response.status === 200 && response.data?.token && response.data.tokenExpiration) {
            localStorage.setItem('us_id', response.data.token)
            localStorage.setItem('us_exp', response.data.tokenExpiration.toString())

            flushPendingClientErrors()
            tokenService.scheduleRefresh(response.data.tokenExpiration)

            set({isAuthorized: true})
        }

        return response
    },

    /** Проверка авторизации пользователя в системе */
    actionCheckAuth: async () => {
        const response = await checkAuth()

        if (response.status === 200 && response.data?.token && response.data.tokenExpiration) {
            localStorage.setItem('us_id', response.data.token)
            localStorage.setItem('us_exp', response.data.tokenExpiration.toString())

            flushPendingClientErrors()
            tokenService.scheduleRefresh(response.data.tokenExpiration)

            set({isAuthorized: true})
        } else if (isAuthenticationRejected(response.status)) {
            set({isAuthorized: false})
            tokenService.abortRefreshToken()

            localStorage.removeItem('us_id')
            localStorage.removeItem('us_exp')
            
            resetStore()
        }

        return response
    },

    /** Выход из системы */
    actionLogout: async () => {
        await logout()
        set({isAuthorized: false})
        tokenService.abortRefreshToken()

        localStorage.removeItem('us_id')
        localStorage.removeItem('us_exp')
        
        resetStore()
    },

    /** Получение профилия пользователя */
    actionGetUserProfile: async () => {
        const response = await getUserProfile()

        if (response.status === 200) {
            set({profile: response.data!})
        }

        return response
    },

}), {name: 'StateLogin'}))